import { render, staticRenderFns } from "./ClientNew.vue?vue&type=template&id=94ee4bb6&"
import script from "./ClientNew.vue?vue&type=script&lang=js&"
export * from "./ClientNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports